"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalManager = void 0;
const _ = __importStar(require("lodash"));
const debug_1 = __importDefault(require("debug"));
const core_1 = require("@integro/core");
const portal_vue_1 = require("portal-vue");
const log = (0, debug_1.default)('itp:ui:components:modal:modal-manager');
const MODAL_TARGET = 'imodal';
const createId = (opts) => `${opts.name}-${(0, core_1.uniqueID)()}`;
class ModalManager {
    $$instances;
    constructor() {
        this.$$instances = [];
    }
    get instances() {
        return this.$$instances;
    }
    errorCaptured(error, vm, info) {
        const lastModal = _.last(this.$$instances);
        if (lastModal) {
            this.close(lastModal.name, { error });
        }
    }
    show(owner, opts) {
        if (opts.maxInstancesPerComponent) {
            const instanceCount = _.filter(this.$$instances, {
                componentName: opts.name
            }).length;
            if (instanceCount > opts.maxInstancesPerComponent) {
                log('stop showing [%s] - max instances exceeded (%s)', opts.name, instanceCount);
                return Promise.resolve({ maxInstancesPerComponentExceeded: true });
            }
        }
        let id = opts.id || createId(opts);
        const from = `modal-${id}`, attrs = {
            id: `${from}`
        }, props = _.extend({
            name: from,
            key: from,
            modalName: from,
            modal: true
        }, opts.props);
        log('SHOW [%s] attrs: %o props: %o', from, attrs, props);
        return new Promise((resolve, reject) => {
            try {
                const passengers = [
                    owner.$root.$createElement(opts.name, {
                        attrs,
                        props: {
                            ...props,
                            componentInitErrorCallback: (error) => this.close(from, { error })
                        },
                        class: {
                            'modal-in-portal': true
                        }
                    })
                ];
                portal_vue_1.Wormhole.open({
                    to: MODAL_TARGET,
                    from,
                    passengers,
                    order: 1
                });
                this.$$instances.push({
                    name: from,
                    componentName: opts.name,
                    resolve,
                    reject
                });
            }
            catch (error) {
                console.log('modal-manager error', error);
                reject(error);
            }
        });
    }
    close(name, result) {
        log('CLOSE [%s] - result: %o', name, result);
        const instance = _.find(this.$$instances, { name }) ||
            _.find(this.$$instances, { componentName: name });
        if (!instance) {
            console.warn(`Modal instance "${name}" does not exist.`);
            return;
        }
        portal_vue_1.Wormhole.close({
            from: instance.name,
            to: MODAL_TARGET
        });
        _.remove(this.$$instances, instance);
        instance.resolve(result);
    }
}
exports.ModalManager = ModalManager;
//# sourceMappingURL=modal-manager.js.map